var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.value.isImage()
    ? _c(
        "a",
        {
          staticClass: "img",
          attrs: {
            href: _vm.value.attachementUrl,
            download: _vm.value.fileName,
            target: "_blank",
          },
        },
        [_c("img", { attrs: { src: _vm.value.attachementUrl } })]
      )
    : _c(
        "a",
        {
          staticClass: "document",
          attrs: {
            href: _vm.value.getEncodedUrl(),
            download: _vm.value.fileName,
            target: "_blank",
          },
        },
        [
          _c("w-fa", { attrs: { icon: "file-pdf" } }),
          _vm._v(" " + _vm._s(_vm.value.fileName)),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }